import { render, staticRenderFns } from "./PaymentForm.vue?vue&type=template&id=b51f0676"
import script from "./PaymentForm.vue?vue&type=script&lang=ts"
export * from "./PaymentForm.vue?vue&type=script&lang=ts"
import style0 from "./PaymentForm.vue?vue&type=style&index=0&id=b51f0676&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports